import React from "react";
import About from "./Components/About/about";
import Homepage from "./Components/HomePage/homePage";
import Lifter from "./Components/Lifter/Lifter";
import Box from "./Components/Box/Box";

function App(){
  return (
    <div className="App">
      <Homepage />
      <About />
      <Lifter />
      <Box />
    </div>
  );
}

export default App;
